import "@app/semantic/semantic";
import { IComponent } from "./IComponent";
import { PageState } from "../services";

export class DropdownComponent implements IComponent {
    attach(element: Element, pageState: PageState, previousState: any) {
        $(element).dropdown();
    }
    getState() {
        return null;
    }
}